export function* numIterator(max: number) {
  let n = 0;
  while (n < max) {
    yield n++;
  }
}
